module.exports = __webpack_public_path__ + "static/media/icons-ic-incoming-call-missed.4526b937.svg";